import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ExtIndiamartConfigModel } from '@smarttask-common/src/lib/models/Integrations/Indiamart/ExtIndiamartConfigModel';

export enum ExtIndiamartConfigActionTypes {
    ADD_EXT_INDIAMART_CONFIG = '[ExtIndiamartConfig] Create ExtIndiamartConfig',
    ADD_EXT_INDIAMART_CONFIGS = '[ExtIndiamartConfig] Add ExtIndiamartConfigs',
    UPSERT_EXT_INDIAMART_CONFIG = '[ExtIndiamartConfig] Upsert ExtIndiamartConfig',
    UPSERT_EXT_INDIAMART_CONFIGS = '[ExtIndiamartConfig] Upsert ExtIndiamartConfigs',
    UPDATE_EXT_INDIAMART_CONFIG = '[ExtIndiamartConfig] Update ExtIndiamartConfig',
    UPDATE_EXT_INDIAMART_CONFIGS = '[ExtIndiamartConfig] Update ExtIndiamartConfigs',
    DELETE_EXT_INDIAMART_CONFIG = '[ExtIndiamartConfig] Delete ExtIndiamartConfig',
    DELETE_EXT_INDIAMART_CONFIGS = '[ExtIndiamartConfig] Delete ExtIndiamartConfigs',
    DELETE_ALL_EXT_INDIAMART_CONFIGS = '[ExtIndiamartConfig] Delete All ExtIndiamartConfigs',
    DELETE_ALL = '[ExtIndiamartConfig] Delete All',

    UPDATE_SELECTED_ID = '[ExtIndiamartConfig] Update SelectedId',
}

export class UpdateSelectedConfigId implements Action {
    readonly type = ExtIndiamartConfigActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_config_id: string) {}
}

export class AddOne implements Action {
    readonly type = ExtIndiamartConfigActionTypes.ADD_EXT_INDIAMART_CONFIG;
    constructor(public config: ExtIndiamartConfigModel) {}
}

export class AddMany implements Action {
    readonly type = ExtIndiamartConfigActionTypes.ADD_EXT_INDIAMART_CONFIGS;
    constructor(public configs: Array<ExtIndiamartConfigModel>) {}
}

export class UpsertOne implements Action {
    readonly type = ExtIndiamartConfigActionTypes.UPSERT_EXT_INDIAMART_CONFIG;
    constructor(public config: ExtIndiamartConfigModel) {}
}

export class UpsertMany implements Action {
    readonly type = ExtIndiamartConfigActionTypes.UPSERT_EXT_INDIAMART_CONFIGS;
    constructor(public configs: Array<ExtIndiamartConfigModel>) {}
}

export class UpdateOne implements Action {
    readonly type = ExtIndiamartConfigActionTypes.UPDATE_EXT_INDIAMART_CONFIG;
    constructor(public config: Update<ExtIndiamartConfigModel>) {}
}

export class UpdateMany implements Action {
    readonly type = ExtIndiamartConfigActionTypes.UPDATE_EXT_INDIAMART_CONFIGS;
    constructor(public configs: Array<Update<ExtIndiamartConfigModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = ExtIndiamartConfigActionTypes.DELETE_EXT_INDIAMART_CONFIG;
    constructor(public config_id: string) {}
}

export class DeleteMany implements Action {
    readonly type = ExtIndiamartConfigActionTypes.DELETE_EXT_INDIAMART_CONFIGS;
    constructor(public config_ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = ExtIndiamartConfigActionTypes.DELETE_ALL_EXT_INDIAMART_CONFIGS;
    constructor(public config_ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = ExtIndiamartConfigActionTypes.DELETE_ALL;
    constructor() {}
}

export type ExtIndiamartConfigActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedConfigId;
